import React from 'react';
import type { ChildrenProp, DivElementProps } from '../common-types';

/**
 * Properties for a {@link GridListTile} component.
 */
export interface GridListTileProps
  extends Required<ChildrenProp>,
    Omit<DivElementProps, 'children'> {
  /**
   * The number of columns that the tile is using.
   */
  cols: number;
  /**
   * The number of rows that the tile is using.
   */
  rows: number;
}

/**
 * Component used together with the GridList component.
 * This is a simple div wrapper that is mostly controlled by its parent GridList.
 *
 * @param properties a {@link GridListTileProps} object.
 * @return the created {@link React.JSX.Element}.
 * @constructor
 */
export function GridListTile({
  className = '',
  // cols and rows are only needed by the GridList (for now)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  cols,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  rows,
  children,
  ...props
}: Readonly<GridListTileProps>): React.JSX.Element {
  return (
    <div className={`grid-list-tile ${className}`.trim()} {...props}>
      {children}
    </div>
  );
}
